import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-20 16:09:49
 * @LastEditTime: 2021-05-25 15:16:57
 * @LastEditors: wangshengqiang
 * @Description: 日期选择
 */
import React from 'react';
import RowDate from '@/components/RowDate';
import { useDisable } from '../RowSex';
export default function RowBirthday(props) {
  const {
    formKey
  } = props;
  const [disabled] = useDisable(formKey);
  return /*#__PURE__*/React.createElement(RowDate, _extends({}, props, {
    disabled: disabled
  }));
}